export function useAccountancyAPI() {
  const { request } = useRequest();

  async function getIsDateInValidFinancialPeriod(dateToCheckString: string) {
    const dateToCheck = new Date(dateToCheckString).toISOString();

    const url = versionedUrl('Accountancy/IsDateInValidFinancialPeriod') + '?dateToCheck=' + dateToCheck;

    return await request<boolean>(url);
  }

  async function getDatesFinancialPeriodStatus(datesToCheck: Date[]) {
    const datesQueryString = datesToCheck.map((date) => 'datesToCheck=' + date.toISOString()).join('&');
    const url = versionedUrl('Accountancy/GetDatesFinancialPeriodStatus') + '?' + datesQueryString;

    const result = await request<Record<string, DateFinancialPeriodStatus>>(url);

    return result;
  }

  async function getDatesFinancialAndSalaryPeriodStatus(datesToCheck: Date[], fitterId: number) {
    const datesQueryString = datesToCheck.map((date) => 'datesToCheck=' + date.toISOString()).join('&');
    const url = versionedUrl('Accountancy/GetDatesFinancialAndSalaryPeriodStatus') + '?' + datesQueryString + '&fitterId=' + fitterId;

    const result = await request<Record<string, DateFinancialAndSalaryPeriodStatus>>(url);

    return result;
  }

  return {
    getIsDateInValidFinancialPeriod,
    getDatesFinancialPeriodStatus,
    getDatesFinancialAndSalaryPeriodStatus
  };
}